import { render, staticRenderFns } from "./AdministrativeActs.vue?vue&type=template&id=18528b48&scoped=true&"
import script from "./AdministrativeActs.vue?vue&type=script&lang=js&"
export * from "./AdministrativeActs.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeActs.vue?vue&type=style&index=0&id=18528b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18528b48",
  null
  
)

export default component.exports